import ActionsButton                                   from '@/components/actionsButton/ActionsButton';
import { Box }                                         from '@chakra-ui/react';
import { Text }                                        from '@chakra-ui/react';
import { useTranslation }                              from 'react-i18next';
import RelationRequestTargetResponseModel              from '@/models/services/network/RelationRequestTargetResponseModel';
import ApiCollection                                   from '@widesk-core/models/ApiCollection';
import RelationRequestTargetResponseStatusModel        from '@/models/services/network/RelationRequestTargetResponseStatusModel';
import { ModalData }                                   from '@/components/modal/Modal';
import RelationRequestTargetResponseStatusHistoryModel from '@/models/services/network/RelationRequestTargetResponseStatusHistoryModel';
import { toaster }                                     from '@/components/ui/toaster';
import ContactModel                                    from '@/models/services/network/ContactModel';
import PagedCollection                                 from '@widesk-core/models/PagedCollection';
import Image                                           from '@/components/Image/Image';

interface IRelationRequestTargetResponseListRowProps {
	contactCollection: ApiCollection<ContactModel>;
	relationRequestTargetResponse: RelationRequestTargetResponseModel;
	relationRequestTargetResponseCollection: PagedCollection<RelationRequestTargetResponseModel>;
	relationRequestTargetResponseStatusCollection: ApiCollection<RelationRequestTargetResponseStatusModel>;
	setModalData: React.Dispatch<React.SetStateAction<ModalData | undefined>>;
	setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const RelationRequestTargetResponseListRow = (props: IRelationRequestTargetResponseListRowProps) => {
	const { contactCollection, relationRequestTargetResponse, relationRequestTargetResponseCollection, relationRequestTargetResponseStatusCollection, setModalData, setModalIsOpen } = props;

	const acceptedStatus = relationRequestTargetResponseStatusCollection.find(m => m.reference === 'accepted') as RelationRequestTargetResponseStatusModel;
	const refusedStatus = relationRequestTargetResponseStatusCollection.find(m => m.reference === 'refused') as RelationRequestTargetResponseStatusModel;

	const { t } = useTranslation();

	const handleRelationRequestResponse = (status: RelationRequestTargetResponseStatusModel) => {
		const isAccepting = status.reference === 'accepted';

		setModalData({
			setIsOpen: setModalIsOpen,
			titleComponent: <Text>{isAccepting ? t('pages.contacts.modals.acceptContact.title') : t('pages.contacts.modals.refuseContact.title')}</Text>,
			bodyComponent: <Text>{isAccepting ? t('pages.contacts.modals.acceptContact.message') : t('pages.contacts.modals.refuseContact.message')}</Text>,
			onClose: () => {
				setModalIsOpen(false);
				setModalData(undefined);
			},
			onConfirm: async () => {
				const history = new RelationRequestTargetResponseStatusHistoryModel();
				
				await history.patch({
					relationRequestTargetResponse: relationRequestTargetResponse?.urn,
					relationRequestTargetResponseStatus: status.urn,
				});
			},
			onError: () => {
				toaster.create({
					title: isAccepting ? t('pages.contacts.modals.acceptContact.error') : t('pages.contacts.modals.refuseContact.error'),
					type: 'error'
				});
			},
			onSuccess: async () => {
				toaster.create({
					title: isAccepting ? t('pages.contacts.modals.acceptContact.success') : t('pages.contacts.modals.refuseContact.success'),
					type: 'success'
				});
				const pendingId = relationRequestTargetResponseStatusCollection.find(m => m.reference === 'pending')?.id
				await relationRequestTargetResponseCollection.setRequiredFilter('relationRequestTargetResponseStatus', pendingId).list();
				await contactCollection.setSort('firstname', 'asc').list();
				setModalIsOpen(false);
				setModalData(undefined);
			}
		})
		setModalIsOpen(true);
	}

	return (
		<Box
			display="flex"
			alignItems="center"
			justifyContent="space-between"
		>
			<Box
				display="flex"
				alignItems="center"
				gap="25px"
			>
				<Box 
					minWidth="75px" 
					maxWidth="75px" 
					height="75px"
				>
					<Image
						errorSize='xl'
						src={relationRequestTargetResponse.requesterPhotoUrl}
						type='profile'
						height="75px"
						width="75px"
						borderRadius="8px"
					/>
				</Box>
				<Box
					display="flex"
					flexDirection="column"
					gap="5px"
					paddingRight="25px"
				>
					<Box><Text className="poppins-semibold" fontSize="16px" textDecoration="underline">{relationRequestTargetResponse.requesterLabel}</Text></Box>
				</Box>
			</Box>
			<ActionsButton actions={[
				{ 
					label: t('pages.contacts.modals.acceptContact.title'), 
					do: () => handleRelationRequestResponse(acceptedStatus),
				},
				{
					label: t('pages.contacts.modals.refuseContact.title'), 
					do: () => handleRelationRequestResponse(refusedStatus),
				},
			]} />
		</Box>
	)
}

export default RelationRequestTargetResponseListRow;